import { readFileSync } from "node:fs";
import { type PricesFile, PriceTable } from "@tktuner/core";

/** Bundled price table, optionally with a user's JSON file merged on top. */
export function loadPriceTable(overridePath?: string): PriceTable {
  if (!overridePath) return PriceTable.bundled();
  const raw = JSON.parse(readFileSync(overridePath, "utf8")) as Partial<PricesFile>;
  return PriceTable.withOverrideData(raw);
}
